import React from 'react';

import ChangeEmail from './ChangeEmail/ChangeEmail';
import ChangePassword from './ChangePassword/ChangePassword';
import CloseAccount from './CloseAccount/CloseAccount';
import LanguageSettings from './LanguageSettings/LanguageSettings';

import styles from './AccountSettings.module.scss';

const AccountSettings = () => (
  <div className={styles.container}>
    <div className={styles.contentBlock}>
      <LanguageSettings />
    </div>
    <div className={styles.contentBlock}>
      <ChangePassword />
    </div>
    <div className={styles.contentBlock}>
      <ChangeEmail />
    </div>
    <div className={styles.contentBlock}>
      <CloseAccount />
    </div>
  </div>
);

export default AccountSettings;
